import { render, staticRenderFns } from "./ProductListBox.vue?vue&type=template&id=439a3e27&"
import script from "./ProductListBox.vue?vue&type=script&lang=js&"
export * from "./ProductListBox.vue?vue&type=script&lang=js&"
import style0 from "./ProductListBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports